// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"bb308929","147":"9fe9b391","156":"097d0179","438":"387cc76a","706":"3269d12e","726":"9dab62f1"}[chunkId] + ".chunk.js";
};